import { useMutation, UseMutationOptions } from 'react-query';

import { useCurrentAssetId } from 'src/Hooks/Shared/useCurrentAssetId';
import { entityExportsApi } from 'src/Services/API';
import {
  CreateEntityExportDtoEntityTypeEnum,
  CreateEntityExportDtoTypeEnum,
  EntityExportDto,
} from 'src/Services/API/generated';
import { trackEvent } from 'src/Services/Matomo';
import { ApiError } from 'src/types/api-error.types';

export const useCreateContactExport = (
  options?: UseMutationOptions<EntityExportDto, ApiError, string[]>
) => {
  const assetId = useCurrentAssetId();

  return useMutation<EntityExportDto, ApiError, string[]>(
    ['create-contact-export', assetId],
    async entityIds => {
      if (!assetId) {
        throw new Error('No asset selected');
      }
      const dto = {
        entityType: CreateEntityExportDtoEntityTypeEnum.Contact,
        type: CreateEntityExportDtoTypeEnum.Static,
        entityIds,
        isPublic: true,
      };

      const response = await entityExportsApi.entityExportsControllerCreate(assetId, dto);
      return response.data;
    },
    {
      ...options,
      onSuccess: (data, variables, context) => {
        trackEvent('Export', 'create', 'contact');
        options?.onSuccess?.(data, variables, context);
      },
    }
  );
};
